// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2YDWx","clinicsSelect":"TableHeading_clinicsSelect__2HS2K"};